export const OralFeaturedMedData = [
  {
    image: "/images/oralmed/img-medication-1.png",
    title: "Sildenafil",
    description: "Sildenafil is the active ingredient in Viagra®, designed to help you achieve and maintain an erection by increasing blood flow to the penis. It typically works within 30–60 minutes and lasts up to 4–6 hours.", 
     className :"border-[10px] border-transparent transition-all duration-300 ease-in-out hover:border-white",
  },
  {
    image: "/images/oralmed/img-medication-2.png",
    title: "Tadalafil",
    description: "Known as the active ingredient in Cialis®, Tadalafil provides longer-lasting results, with effects lasting up to 36 hours. It offers flexibility, allowing you to enjoy spontaneous moments without planning around your medication.", 
     className :"border-[10px] border-transparent transition-all duration-300 ease-in-out hover:border-white",
  },
  {
    image: "/images/oralmed/img-medication-3.png",
    title: "Oxytocin",
    description: "Oxytocin, sometimes referred to as the \"love hormone\", enhances emotional connection and intimacy. It is used in specific cases to improve sexual satisfaction and bonding between partners.", 
     className :"border-[10px] border-transparent transition-all duration-300 ease-in-out hover:border-white",
  },
];